import { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";
import "../styles/price.css";

const Price = () => {
  const [content, setContent] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    fetch("/static/content/price.md", { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error("Unable to load session details");
        return response.text();
      })
      .then((text) => {
        setContent(text);
      })
      .catch((error) => {
        if (error.name !== "AbortError") setError(true);
      });
    return () => controller.abort();
  }, []);

  return (
    <Layout>
      <div className="price-container">
        {!content && !error && <p role="status">Загружаем информацию о съёмках…</p>}
        {error && <p role="alert" className="price-error">Не удалось загрузить информацию. Напишите мне в Инстаграм — я расскажу о съёмке и стоимости.</p>}
        <div className="price-content" lang="ru">
          <ReactMarkdown
            components={{
              strong: ({ node, ...props }) => (
                <b className="price-highlight" {...props} />
              ),
              p: ({ node, ...props }) => (
                <p className="price-paragraph" {...props} />
              ),
              h2: ({ node, children, ...props }) => (
                <h2 className="price-title" {...props}>
                  {children}
                </h2>
              ),
              h3: ({ node, children, ...props }) => (
                <h3 className="price-subtitle" {...props}>
                  {children}
                </h3>
              ),
              hr: () => <div className="price-divider" />,
              ul: ({ node, ...props }) => (
                <ul className="price-list" {...props} />
              ),
              li: ({ node, ...props }) => (
                <li className="price-list-item" {...props} />
              ),
              a: ({ node, children, ...props }) => (
                <a
                  className="price-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  {...props}
                >
                  {children}
                </a>
              ),
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
        <div className="price-actions">
          <a className="outline-button price-booking" href="https://ig.me/m/darianemkovich" target="_blank" rel="noopener noreferrer">Записаться на съёмку</a>
          <Link to="/" className="price-return">Вернуться к контактам</Link>
        </div>
      </div>
    </Layout>
  );
};

export default Price;
